// src/components/pages/portfolios/Portfolios.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import styles from './style/Portfolios.module.css';

import NewPortfolioModal from './modal/NewPortfolioModal.js';
import LoginPromptToast from '../../partials/LoginPromptToast/LoginPromptToast.js';
import LiveRankings from './partials/Rank-LiveRank.js';
import HallOfFame from './partials/Rank-HallOfFame.js';
import ChallengeCta from "../../partials/ChallengeCta/ChallengeCta";

export default function Portfolios() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  
  const [activeTab, setActiveTab] = useState('live'); 
  const [showModal, setShowModal] = useState(false);
  const [isGuideOpen, setIsGuideOpen] = useState(false);

  const handleNewPortfolioClick = () => {
    if (auth.isAuthenticated) {
      setShowModal(true);
    } else {
      toast.error(
        <LoginPromptToast 
          signInRedirect={auth.signinRedirect} 
          navigate={navigate} 
        />
      );
    }
  }; 

  return (
    <div className={styles.portfolioContainer}>
      {/* 팝업이 열려있을 때 배경 어디든 누르면 닫히게 하는 투명 레이어 */}
      {isGuideOpen && (
        <div className={styles.popoverOverlay} onClick={() => setIsGuideOpen(false)} />
      )}

      <h2 className={styles.portfolioTitle}>{t('portfolios.title')}</h2>
      
      <div className={styles.tabContainer}>
        <button 
            className={`${styles.tabButton} ${activeTab === 'live' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('live')}
        >
            {t('portfolios.liveTab')}
        </button>
        <button 
            className={`${styles.tabButton} ${activeTab === 'fame' ? styles.activeTab : ''}`}
            onClick={() => {
              setActiveTab('fame');
              setIsGuideOpen(false); 
            }}
        >
            {t('portfolios.fameTab')}
        </button>
      </div>

      <div className={styles.updateInfoArea}>
        {activeTab === 'live' ? (
          <p className={styles.updateInfoText}>{t('portfolios.updateInfo')}</p>
        ) : (
          <div className={styles.fameInfoWrapper}>
            <div 
              className={styles.infoIconTrigger}
              onClick={() => setIsGuideOpen(!isGuideOpen)}
            >
              <FontAwesomeIcon icon={faCircleInfo} />
            </div>

            {isGuideOpen && (
              <div className={styles.fameFloatingGuide}>
                <div className={styles.guideHeader}>
                  <button className={styles.closeBtn} onClick={() => setIsGuideOpen(false)}>×</button>
                </div>
                
                <div className={styles.guideBody}>
                  <div className={styles.guideItem}>
                    <span className={styles.guideLabel}>{t('portfolios.fame.selectionCriteria')}</span>
                    <span className={styles.guideValue}>{t('portfolios.fame.selectionValue')}</span>
                  </div>
                  
                  <div className={styles.guideItem}>
                    <span className={styles.guideLabel}>{t('portfolios.fame.update')}</span>
                    <span className={styles.guideValue}>{t('portfolios.fame.updateValue')}</span>
                  </div>
                  
                  <div className={styles.guideItem}>
                    <span className={styles.guideLabel}>{t('portfolios.fame.ranking')}</span>
                    <span className={styles.guideValue}>{t('portfolios.fame.rankingValue')}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {activeTab === 'live' ? (
          <LiveRankings navigate={navigate} t={t} styles={styles} />
      ) : (
          <HallOfFame navigate={navigate} t={t} />
      )}
      
      {/* === 경쟁 등록 버튼 === */}
      <ChallengeCta/>      

      {showModal && auth.isAuthenticated && (
        <NewPortfolioModal onClose={()=>setShowModal(false)} onCreated={(id)=>{setShowModal(false);navigate(`/portfolios/${id}`);}} />
      )}
      
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={true}
        draggable={true}
        pauseOnHover={true}
      />
    </div>
  );
}